import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Layout,
  Input,
  Button,
  Divider,
  Table,
  MenuProps,
  Dropdown,
  Modal,
  Checkbox,
  Form,
  Select,
  Card,
  Image,
} from "antd";
import { getMetalsService, getCompletedBundlesService, getShippedBundlesService } from "./BundlesPageService";
import "./BundlesPage.css";
import Copyright from "../../components/Copyright/Copyright";
import {
  ArrowDownOutlined,
  ArrowRightOutlined,
  DeleteOutlined,
  EditOutlined,
  FolderOpenOutlined,
  MoreOutlined,
  ReloadOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import Header from "../../components/Header/Header";
import Loader from "../../components/Loader/Loader";
import Sidebar from "../../components/Sidebar/Sidebar";
import Cookies from "universal-cookie";
import { removeTokenFromCookies } from "../../utils/cookies";

const { Content } = Layout;

export interface InventoryPageInterface {}

const BundlesPage = (props: InventoryPageInterface) => {
  const [loading, setLoading] = useState(false);
  const [inventoryMaterialData, setInventoryMaterialData] = useState({}) as any;
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [completedBundlesList, setCompletedBundlesList] = useState([]) as any;
  const [shippedBundlesList, setShippedBundlesList] = useState([]) as any;
  const [metals, setMetals] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [bundleToDelete, setBundleToDelete] = useState({}) as any;
  const [shippedBundlesTotalPages, setShippedBundlesTotalPages] = useState(0);
  const [totalShippedBundles, setTotalShippedBundles] = useState(0);
  const [completedBundlesTotalPages, setCompletedBundlesTotalPages] = useState(0);
  const [totalCompletedBundles, setTotalCompletedBundles] = useState(0);
  const [currentCompletedBundlesPage, setCurrentCompletedBundlesPage] = useState(1);
  const [currentShippedBundlesPage, setCurrentShippedBundlesPage] = useState(1);
  const cookies = new Cookies();
  const userRole = cookies.get("USER_ROLE");
  const currOffice = cookies.get("CURR_OFFICE");
  let navigate = useNavigate();

  const completedBundleColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Image",
      key: "index",
      render: (record: any) =>
        record.imageURL ? (
          <Image
            height={50}
            width={50}
            src={record.imageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#FFFFFF" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#FFFFFF" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#FFFFFF" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        ) : (
          <></>
        ),
      align: "center" as const,
    },
    {
      title: "Date",
      key: "date",
      align: "center" as const,
      width: "7.5%",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center" as const,
      width: "7.5%",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Material Name",
      key: "materialName",
      align: "left" as const,
      render: (record: any) => {
        // const metalRecord: any = metals.find((metal: any) => record.metalID === metal.metalID);
        return record.displayName !== undefined ? record.displayName : "";
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(2),
    },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        record.shipped && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Bundle", icon: <FolderOpenOutlined /> })
          : items.push({ key: "edit", label: "Edit Bundle", icon: <EditOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Bundle", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editBundle(record);
                else if (key === "delete") openDeleteBundleModal(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const shippedBundleColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Image",
      key: "index",
      render: (record: any) => (
        <Image
          height={50}
          width={50}
          src={record.imageURL}
          preview={{
            toolbarRender: () => (
              <>
                <h1 style={{ color: "#FFFFFF" }}>{record.displayName}</h1>
                <h3 style={{ color: "#FFFFFF" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                <h3 style={{ color: "#FFFFFF" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
              </>
            ),
          }}
        />
      ),
      align: "center" as const,
    },
    {
      title: "Date",
      key: "date",
      align: "center" as const,
      width: "7.5%",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center" as const,
      width: "7.5%",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Material Name",
      key: "materialName",
      align: "left" as const,
      render: (record: any) => {
        // const metalRecord: any = metals.find((metal: any) => record.metalID === metal.metalID);
        return record.displayName !== undefined ? record.displayName : "";
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(2),
    },
    {
      title: "Shipment Date",
      key: "shippedTimestamp",
      align: "center" as const,
      render: (record: any) =>
        `${new Date(record.shippedTimestamp).toLocaleDateString("en-GB")} ${new Date(
          record.createdTimestamp
        ).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })}`,
    },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        record.shipped && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Bundle", icon: <FolderOpenOutlined /> })
          : items.push({ key: "edit", label: "Edit Bundle", icon: <EditOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Bundle", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editBundle(record);
                else if (key === "delete") openDeleteBundleModal(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getMetals();
  }, []);

  useEffect(() => {
    getCompletedBundles();
    getShippedBundles();
  }, [metals]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getCompletedBundles = async () => {
    try {
      setLoading(true);
      const res = await getCompletedBundlesService(String(currentShippedBundlesPage));
      setCompletedBundlesTotalPages(res.data.totalPages);
      setTotalCompletedBundles(res.data.totalBundles);
      const bundleList = res.data.bundles.map((bundle: any) => {
        if (metals.length > 0) {
          const metalRecord: any = metals.find((metal: any) => bundle.metalID === metal.metalID);
          bundle.displayName = metalRecord.displayName;
        }
        bundle.key = bundle.materialID;
        return bundle;
      });
      setCompletedBundlesList(bundleList);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getCompletedBundles error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getShippedBundles = async () => {
    try {
      setLoading(true);
      const res = await getShippedBundlesService(String(currentShippedBundlesPage));
      setShippedBundlesTotalPages(res.data.totalPages);
      setTotalShippedBundles(res.data.totalBundles);
      const bundleList = res.data.bundles.map((bundle: any) => {
        if (metals.length > 0) {
          const metalRecord: any = metals.find((metal: any) => bundle.metalID === metal.metalID);
          bundle.displayName = metalRecord.displayName;
        }
        bundle.key = bundle.materialID;
        return bundle;
      });
      setShippedBundlesList(bundleList);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getShippedBundles error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7200000 ? true : false;
  };

  const editBundle = (record: any) => {
    navigate(`/bundle/${record.materialID}`);
  };

  const openDeleteBundleModal = (record: any) => {
    setBundleToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const navToLoginPage = () => {
    navigate("/login");
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="purchases-title">Bundles</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => {
                      getCompletedBundles();
                      getShippedBundles();
                    }}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row align="top" style={{ overflowY: "auto", height: "40vh" }}>
              <h2 className="purchases-title">Completed Bundles</h2>
              <Table
                className="inventory-table"
                dataSource={[...completedBundlesList]}
                columns={completedBundleColumns}
                pagination={false}
                sticky
              />
            </Row>
            <Row style={{ overflowY: "auto", height: "40vh" }}>
              <h2 className="purchases-title">Shipment Bundles</h2>
              <Table
                className="inventory-table"
                dataSource={[...shippedBundlesList]}
                columns={shippedBundleColumns}
                pagination={false}
                sticky
              />
            </Row>
          </Col>
        </Row>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default BundlesPage;
